/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = Purchase.MaterialInItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MaterialInJobWork extends _Ext.GridEditorBase<Purchase.MaterialInItemsRow> {


        protected getColumnsKey() { return "Purchase.MaterialForJobWorkReceipt"; }
        protected getDialogType() { return Purchase.MaterialInItemsDialog; }
        protected getLocalTextPrefix() { return Purchase.MaterialInItemsRow.localTextPrefix; }
        protected form: Purchase.MaterialInItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = false;
            return opt;
        }

        // #region Variables
        public PartyId: number;
        public ProductId: number;
        public BOMProductIds: any[];
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = true;
        private contractTotals: string;
        public TotalItems: number;
        public ProductTypeId: number;
        public isUpdate: boolean;
        statement: string;
        static LineNo: number;
        static Items: JobWork.JobWorkItemsRow;
        public closed: boolean;
        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
        }



        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            //var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            //var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            //var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);

            ////var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            ////Department.referencedFields = [fld.DepartmentId];
            ////Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup());

            
            //Q.first(columns, x => x.field === fld.Pieces).format = int;

            //let itemtype = Q.first(columns, x => x.field === fld.Pieces);

            //itemtype.format = ctx => {
            //    if (ctx.item.ItemTypeId == 105)
            //        return ColumnFormatter.integerInputFormatter(ctx, this);
            //}

            /////Q.first(columns, x => x.field === fld.Pieces).format = int;
            //Q.first(columns, x => x.field === fld.Weight).format = num;


            ////To Add Delete Button on Item Row
            //columns.unshift({
            //    field: 'Delete Row',
            //    name: '',
            //    format: ctx => '<a class="inline-action delete-row" title="delete">' +
            //        '<i class="fa fa-trash-o text-red"></i></a>',
            //    width: 24,
            //    minWidth: 24,
            //    maxWidth: 24
            //});

            return columns;
        }

        // #endregion

        public getTotalRows(Item: any) {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();


                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            if (target.hasClass('edit numeric')) {
                e.preventDefault();

                if (target.hasClass('edit numeric')) {
                    // var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                    //TODO: Need to add System Parameter to enable disable blocking
                    var input = $(e.target);
                    if (input != undefined) {
                        let values;

                        var input = $(e.target);
                        var y = input.data();
                        if (y.field == "Weight" && item.ItemTypeId == 101) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                            target.addClass('readonly');
                            target.blur();
                        }

                    }

                    this.view.refresh();
                }
            }
        }

        public setData(Items: any[]) {
            //set data in Material Grid from Job Work
            //this.Items = Items;
            let BOMdetails;
            for (let item of Items) {
                BOMdetails = item.BOMDetails;
                for (var BOM of BOMdetails) {
                    var exists: boolean = false;
                    var PrdDetails: OMS.ProductMasterRow;
                    OMS.ProductMasterService.Retrieve({ EntityId: BOM.BOMProductId }, response => PrdDetails = response.Entity, { async: false });

                    if (PrdDetails.ItemTypeId != 104) {
                        var detail: Purchase.MaterialInItemsRow = {
                            AttributeId: BOM.BOMAttributeId,
                            ProductCode: BOM.ProductCode,
                            ProductId: BOM.BOMProductId,
                            DepartmentId: item.DepartmentId,
                            ProductName: BOM.ProductName,
                            SKU: item.SKU,
                            Line_No: item.Line_No,
                            Pieces: BOM.Pieces == null ? 0 : BOM.Pieces,
                            Weight: BOM.Weight,
                            HSN: item.HSN,
                            Attribute: PrdDetails.Attribute,
                            CalcOnId: BOM.CalcOnId,
                            Purity: PrdDetails.Purity
                        };
                        //  JobWork.JobWorkDialog.editorClosed = true;
                        var x = this.view.getItems();
                        x.forEach(function (value) {

                            if (value.Line_No == detail.Line_No && value.ProductId == BOM.BOMProductId)
                                exists = true;
                        });
                        if (exists == false) {
                            detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(detail);
                        }
                        else {
                            Q.notifyWarning("RM Already Issued!!");
                        }

                    }

                }
            }
        }

        public setBOMData(item: JobWorkReceiptBOMRow) {
            //set data in Material Grid from Job Work
            //this.Items = Items;

            //if (item.ItemTypeId != 104) {
                var detail: Purchase.MaterialInItemsRow = {
                    AttributeId: item.AttributeId,
                    ItemTypeId:item.ItemTypeId,
                    ProductCode: item.ProductCode,
                    ProductId: item.ProductId,
                    Pieces: item.Pieces == null ? 0 : item.Pieces,
                    Weight: item.Weight,
                    Attribute: item.Attribute,
                    CalcOnId: item.CalcOnId,
                    Purity: item.Purity == undefined ? 0 : item.Purity
                };
                var currentitems = this.view.getItems();
                var exists = false;
                for (var i = 0; i < currentitems.length; i++) {
                    var currentitem = currentitems[i];
                    if (currentitem.AttributeId == detail.AttributeId && currentitem.ProductId == detail.ProductId) {
                        currentitem.Pieces = detail.Pieces;
                        currentitem.Weight = detail.Weight;
                        detail = currentitem;
                        exists = true;
                    }
                }
                if (exists) {
                    this.view.updateItem(this.id(detail), detail);
                    this.view.refresh();
                } else {

                    detail[this.getIdProperty()] = "`" + this.nextId++;
                    this.view.addItem(detail);
                }
            //}



        }

        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseInteger(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            } else if (field === fld.Weight || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }
            var stockdata: Stock.StockItemRow[];
            Stock.StockItemService.CustomMaterialOutList({
                ProductIds: [item.ProductId],
                LineNos: [parseInt(item.Line_No.toString()), 0],
                ItemTypeIds: [105]
            }, function (response) {
                return stockdata = response.Entities;
            }, { async: false });
            // *** Update Weight, Amount etc on Pieces Change***
            stockdata = stockdata.filter(x => x.ProductId == item.ProductId && x.AttributeId == item.AttributeId)
            if (field === fld.Pieces && value > 0) {
                if (value < stockdata[0].Pieces && item.Weight == stockdata[0].Weight) {
                    q.alert('Error', 'Invalid Pieces', true);
                    return;
                }

                else
                    item[field] = value;

                if (item.CalcOnId == 3) {
                    if (stockdata.length > 0 && stockdata[0].Pieces >= value) {
                        item.GrossAmount = item.UnitRate * value;
                        item.NetAmount = item.UnitRate * value;

                        item[field] = value;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                    } else {
                        Q.notifyError('Invalid Quantity', '', null);
                        input.val(oldText);
                        input.focus();
                        return;
                    }
                }
                else {
                    if (stockdata.length > 0 && stockdata[0].Pieces >= value) {
                        //item.GrossAmount = item.UnitRate * value;
                        //item.NetAmount = item.UnitRate * value;

                        item[field] = value;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                    } else {
                        Q.notifyError('Invalid Quantity', '', null);
                        input.val(oldText);
                        input.focus();
                        return;
                    }
                }
            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {

                if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    if (stockdata.length > 0 && stockdata[0].Weight >= value) {
                        item.GrossAmount = item.UnitRate * value;
                        item.NetAmount = item.UnitRate * value;
                        item.NetWeight = value;
                        item[field] = value;
                        this.view.updateItem(id, item);
                        this.view.refresh();
                    }
                } else {
                    Q.notifyError('Invalid Quantity', '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons.pop();

            return buttons;
        }



        // #endregion

    }
}